import { themeNames } from '@upgrade/themes';
const ENV_APP_PREFIXES = ['REACT_APP_', 'GATSBY_', 'STORYBOOK_'];
const UNIVERSAL_CREDIT_HOSTNAME_ENV_KEY = 'UNIVERSAL_CREDIT_HOSTNAME';
export const getCurrentThemeName = env => {
  if (global.location && global.location.hostname && ENV_APP_PREFIXES.some(appEnvPrefix => env[`${appEnvPrefix}${UNIVERSAL_CREDIT_HOSTNAME_ENV_KEY}`] === global.location.hostname)) {
    return themeNames.UNIVERSAL_CREDIT_THEME_NAME;
  }
  return themeNames.UPGRADE_THEME_NAME;
};
export const isUniversalCreditHostname = env => getCurrentThemeName(env) === themeNames.UNIVERSAL_CREDIT_THEME_NAME;
export const getThemedEnv = env => {
  if (!global.location) {
    return env;
  }
  const themedEnv = {
    ...env
  };
  const themeName = getCurrentThemeName(env);
  if (themeName) {
    Object.keys(themedEnv).forEach(envKey => {
      ENV_APP_PREFIXES.forEach(envAppPrefix => {
        const [, envKeyWithoutAppPrefix] = envKey.split(envAppPrefix);
        if (envKeyWithoutAppPrefix) {
          const themedEnvKey = `${envAppPrefix}${themeName.toUpperCase()}_${envKeyWithoutAppPrefix}`;
          if (env[themedEnvKey]) {
            themedEnv[envKey] = themedEnv[themedEnvKey];
          }
        }
      });
    });
  }
  return themedEnv;
};